<template>
    <div class="startCreatePostDetails spackage padding-20 bgc box-shadow">
        <!-- start 顶部菜单栏 -->

        <el-form :model="form" :rules="rules">

            <el-form-item label="标题">
                <el-input style="width: 436px" placeholder="输入标题，不能超过30个字" v-model="form.subject" maxlength="30"></el-input>
            </el-form-item>

            <el-form-item label="话题" placeholder="选择话题">
                <el-select v-model="form.tagid">
                    <el-option v-for="item in taglist" :key="item.innerid" :value="item.innerid" :label="item.tagname"></el-option>
                </el-select>
            </el-form-item>

             <el-form-item label="选择栏目" placeholder="选择栏目">
                <el-select v-model="form.columninnerid">
                    <el-option v-for="item in columninneridList" :key="item.innerid" :value="item.innerid" :label="item.columnname"></el-option>
                </el-select>
            </el-form-item>

            <el-form-item label="内容详情" porp="content" required>
                <div class="ueditorBox">
                    <uEditor :content="form.content" ref="uEditor" @getUEditorContent="getMsgContent"></uEditor>
                </div>


                <div style="margin-left: 80px;margin-top: 20px">
                    <div class="upload-pdf">

                        <template v-if="videostatus == false">
                            <Uploads v-if="imglogodata.length < 9" :uploadType="uploadImgType" @setFile="setFile" :fileRule="fileRule"></Uploads>
                            <el-button v-else type="info">添加图片</el-button>
                        </template>
                        <templae v-else>
                            <el-button type="info">添加图片</el-button>
                        </templae>


                        <template v-if="imgstatus == false">
                            <uploadFile style="margin-left: 20px" :uploadType="uploadVideoType" @setFile="setVideoFile" :fileRule="fileVideoRule"></uploadFile>
                        </template>
                        <template v-else>
                            <el-button style="margin-left: 20px" type="info">添加视频</el-button>
                        </template>


                        <span style="margin-left: 20px">最多上传9张图片或1个视频</span>
                    </div>
                    <div class="pdfMsg" v-if="imglogodata.length">
                        <div class="item" v-for="(logodata,index) in imglogodata">
                            <img :src="logodata.furl"></el-image>
                            <i class="el-icon-close" @click="delImg(index)"></i>
                        </div>
                    </div>

                    <div class="videoMsg" v-if="videoInfo.length">
                        <div class="item" v-for="video in videoInfo">
                            <a class="fname" :href="video.furl" target="_blank">{{video.fname}}</a>
                            <span @click="delVideoFUle">删除</span>
                        </div>
                    </div>
                </div>

            </el-form-item>

            <el-form-item label=" ">
                <el-button style="margin-left: 80px" @click="back">取消</el-button>
                <el-button style="margin-left: 20px" type="primary" @click="add">保存</el-button>
            </el-form-item>
        </el-form>
    </div>
</template>

<script>
    import {getStarTagList, saveCwKmcStarsubjectinfo, getCwKmcStarcolumnsubjectinfo} from '@/api/communityApi'
    import UEditor from 'base/uEditor/uEditor'
    import Uploads from 'base/upload/uploads'
    import UploadFile from 'base/upload/uploadFile'
    import Loading from 'base/loading/loading' // 引入 loading 组件
    import {computeFileSize, formatFileInfo} from 'common/js/tools'
    import {mapGetters,mapActions} from 'vuex'
    export default {
        name: "startCreatePostDetails",
        data() {
            return {
                taglist: [],    // 话题列表
                innerid: this.$route.query.innerid,
                uploadImgType: {
                    catecode: '95',
                    datatype: 'IMAGE'
                },
                imgstatus: false,
                videostatus: false,
                vsource: '1', // 视频来源 1 直接上传 2视频素材
                videoInfo: [], // 视频
                imglogodata: [],
                columninneridList: [{innerid:'',columnname:'默认'}],
                form: {
                    starinnerid: this.innerid,
                    columninnerid: '',
                    subject: '',  //标题
                    tagid: '',  // 话题id
                    logodata: [],
                    content: '',
                    contenttype: 1,
                },
                uploadVideoType: {
                    catecode: '95',
                    datatype: 'VIDEO'
                },
                fileVideoRule: {
                    btnName: '添加视频',
                    cls: '',
                    accept: 'video/mp4',
                    size: 1 * 1024,
                    width: '',
                    height: ''
                },

                fileRule: {
                    btnName: '添加图片',
                    cls: '',
                    accept: 'image/png,image/jpeg',
                    size: 5,
                    width: '750',
                    height: '1334'
                },
                rules: {
                    content: [
                        { required: true, message: '请输入内容详情', trigger: 'blur' },
                    ],
                    subject:[
                        { required: true, message: '请输入标题名称', trigger: 'blur' },
                        { min: 1, max: 10, message: '标题名称长度在 1 到 10 个字符', trigger: 'blur' }
                    ],
                    tagid: [
                        { required: true, message: '请选择话题', trigger: 'blur' },
                    ],

                    innerid: [
                        { required: true, message: '请选择马甲', trigger: 'blur' },
                    ]
                }
            }
        },
        mounted() {
            // 取得话题列表
            this.tablist()
            // 取得栏目列表
            this.getCwKmcStarcolumnsubjectinfolist()
        },
        methods: {
            back() {
                this.$router.go(-1)
            },
            getCwKmcStarcolumnsubjectinfolist(){
                this.setLoading(true)
                getCwKmcStarcolumnsubjectinfo({
                    data: {starid:this.innerid},
                    success:data => {
                        this.columninneridList = this.columninneridList.concat(data.data.content)
                         this.setLoading(false)
                    },
                    error:data => {
                        this.$message.error(data.msg)
                        this.setLoading(false)
                    }
                })
            },
            // 内容详情
            getMsgContent(content) {
                this.form.content = content
            },
            setFile(file) {
                console.log('file',file)
                computeFileSize()
                delete file.type
                this.imglogodata.push(file)
                this.imgstatus = true
                console.log('logodata',this.imglogodata)
                // = file
            },
            setVideoFile(file) {
                this.vsource = '1'

                if (this.videoInfo.length < 1) {
                    delete file.type
                    this.videoInfo.push(file)
                    this.videostatus = true
                    console.log('video',file)

                } else {
                    this.$message.error('最多上传一个视频')
                }



            },
            delVideoFUle() {

                this.videoInfo = []
                this.videostatus = false
            },
            delImg(index) {
                let len = this.imglogodata.length,
                    logolist = this.imglogodata

                for (let i = 0; i < len; i++ ) {
                    if ( i === index ) {
                        this.$nextTick(() => {
                            logolist.splice(i,1)
                            if (i === 0) {
                                this.imgstatus = false
                            }
                        })

                    }
                }
            },
            back() {
                this.$router.go(-1)
            },
            add() {
                let data = JSON.parse(JSON.stringify(this.form))

                if (this.imgstatus === true) {
                    data.imgs = JSON.stringify(this.imglogodata)
                    data.contenttype = 1

                } else if (this.videostatus === true) {
                    data.videoInfo = JSON.stringify(this.videoInfo)
                    data.contenttype = 2
                }
                // else {
                //     this.$message.error('请至少上传一个图片/视频')
                //     return
                // }

                data.starid = this.innerid

                if (data.content === "" && this.imgstatus === false && this.videostatus === false && data.subject === "") {
                    this.$message.error('标题、内容、图片/附件 请至少上传一样')
                } else {

                    this.setLoading(true)

                    saveCwKmcStarsubjectinfo({
                        data: data,
                        success: data => {
                            this.$message.success('保存成功')
                            this.setLoading(false)
                            // this.initform()
                            this.back()
                        },
                        error: data => {
                            this.$message.error(data.msg)
                            this.setLoading(false)
                        }
                    })
                }
            },
            initform() {
            },
            tablist() {
                let dataapi = {
                    starinnerid: this.innerid
                }
                this.setLoading(true)
                getStarTagList({
                    data: dataapi,
                    success:data => {
                        this.taglist = data.data
                        this.setLoading(false)
                    },
                    error:data => {
                        this.setLoading(false)
                    }
                })

            },
            ...mapActions([
                'setLoading'
            ]),
        },
        computed: {
            fsize () {
                return function(size) {
                    return computeFileSize(size)
                }
            },
        },
        components: {
            Loading,
            UEditor,
            UploadFile,
            Uploads
        },
    }
</script>

<style lang="scss" type="text/scss">
    @import "~common/scss/variable";
    @import "~common/scss/mixin";
    .startCreatePostDetails {
        #edui62_body {
            display: none
        }
        .el-input__icon {
            line-height: normal;
        }
        .el-form-item__label {
            width: 78.22px;
        }
        .name {
            margin-bottom: 20px;
            padding-left: 8px;
            font-size: 16px;
            font-weight: bold;
            border-left: solid 2px #00a0e9;
        }

        .pdfMsg{
            display: flex;
            flex-wrap: wrap;
            justify-content: flex-start;
            margin-top: 20px;
            margin-right: 20px;
            height: 100px;
            box-sizing: border-box;
            .item {
                position: relative;
                display: inline-block;
                margin-right: 10px;
                margin-bottom: 20px;
                width: 110px;
                height: 110px;
                i {
                    position: absolute;
                    right: -7px;
                    top: -6px;
                    width: 20px;
                    height: 20px;
                    text-align: center;
                    line-height: 20px;
                    border-radius: 50%;
                    font-size: 12px;
                    color: #fff;
                    background: rgba(0,0,0,.3);
                }
                img {
                    width: 100%;
                    height: 100%;
                }
            }
        }
        .videoMsg {
            margin-top: 20px;
            width: 264px;
            line-height: 40px;
            -webkit-box-sizing: border-box;
            box-sizing: border-box;
            padding: 0 20px;
            overflow: hidden;
            background: #DCDFE6;
            margin-bottom: 10px;

            .item {
                a {
                    float: left;
                    display: inline-block;
                    padding-right: 10px;
                    width: 150px;
                    text-overflow: ellipsis;
                    overflow: hidden;
                    white-space: nowrap;
                }
                span {
                    float: right;
                    padding-right: 10px;
                    color: #409EFF;
                    cursor: pointer;
                }
            }
        }
        .upload-pdf{
            @include flexBox(flex-start);
            display: flex;
            flex-wrap: wrap;
            justify-content: flex-start;
        }
    }
</style>
